import type { ReactNode } from 'react'
import { cx } from '@/utils/cx'

/**
 * Ein Hinweis im Fluss der Seite — Erfolg, Fehler, oder etwas zu wissen.
 *
 * Dieselbe Bauform wie `Fehler` in `Tabelle.tsx`, nur mit drei Tönen:
 * gerundete Fläche in der Farbe der Lage, kein Rahmen, kein Symbol. Die
 * Farbe trägt die Aussage nicht allein — der Titel sagt sie.
 *
 * `role="status"` meldet die Änderung an Vorleseprogramme, ohne den Fokus
 * zu verschieben — nach einem Absenden genau richtig.
 */
export function Hinweis({
  art = 'info',
  titel,
  children,
}: {
  art?: 'info' | 'erfolg' | 'fehler'
  titel?: string
  children?: ReactNode
}) {
  return (
    <div
      role="status"
      className={cx(
        'rounded-xl p-4 text-sm',
        art === 'fehler' && 'bg-error-primary text-error-primary',
        art === 'erfolg' && 'bg-success-primary text-success-primary',
        art === 'info' && 'bg-akzent-flaeche text-akzent-tief',
      )}
    >
      {titel ? <p className="font-semibold">{titel}</p> : null}
      {children ? <div className={titel ? 'mt-1' : ''}>{children}</div> : null}
    </div>
  )
}
